import * as _ from "lodash";

// istanbul ignore next - this is just a wrapper around memoize
export function memoize<T>(cls: T, key: keyof T): void {
  if (_.isFunction(cls[key])) {
    // @ts-ignore - I have no idea how to type this
    cls[key] = _.memoize(cls[key]);
  }
}
